(function ($) {

    $(document).ready(function () {
        $('.osm-map.populate').each( (index, element) => {
            const $osmMap = $(element);
            const $markerPopUps = $osmMap.find(".marker");
            const openStreetMapVO = createDefaultOpenStreetVO($osmMap, $markerPopUps);
            openStreetMapVO.defaultZoomLevel = 10;
            openStreetMapVO.disableClusteringAtZoom = 10;

            createOpenStreetMap(openStreetMapVO);
            $($osmMap.find(".leaflet-marker-pane img")[0]).trigger( "click" );
        });
    });
})(jQuery);